import React from 'react';

import styled from 'styled-components';

import { ProgressBar } from 'components/progress-bar';

import theme from './theme';
import { IFreeDeliveryProgressProps } from './types';

const FREE_DELIVERY_ELIGIBLE = 100;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #aaaaaa;
  padding: 10px 0 0 0;
  margin: 10px 0 0 0;
`;
const Title = styled.div`
  color: ${theme.freeDeliveryTitleColor};
  font-weight: ${Styles.fontWeight.heavy};
`;

const SubText = styled.div`
  color: ${theme.subTextColor};
`;

const FreeDeliveryProgress: React.FC<IFreeDeliveryProgressProps> = ({
  freeDeliveryPercentageComplete,
  titleLabel,
  freeDeliveryReachedLabel,
  freeDeliveryInProgressLabel,
}) => (
  <Container data-testid="free-delivery-progress">
    <Title>{titleLabel}</Title>
    <ProgressBar percentage={freeDeliveryPercentageComplete} fillColor={theme.progressFillColor} />
    <SubText>
      {FREE_DELIVERY_ELIGIBLE === freeDeliveryPercentageComplete
        ? freeDeliveryReachedLabel
        : freeDeliveryInProgressLabel}
    </SubText>
  </Container>
);
export default FreeDeliveryProgress;
